import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LoadingSpinnerComponent } from '../../../loading/loading-spinner/loading-spinner.component';
import { IconComponent } from '../../../icon/icon.component';
import { BaseProgressComponent } from '../base-progress.component';

@Component({
  selector: 'nrc-download-progress',
  standalone: true,
  imports: [
    CommonModule,
    IconComponent,
    LoadingSpinnerComponent
  ],
  templateUrl: './download-progress.component.html',
  styleUrl: './download-progress.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DownloadProgressComponent extends BaseProgressComponent {}
